export default {
    Monthly: 0,
    Yearly: 1,
    Both: 2
  }